const moment = require('moment')

module.exports = {
    testEmailValidity(email) {
        const regex = new RegExp(
            `([-!#-'*+/-9=?A-Z^-~]+(\\.[-!#-'*+/-9=?A-Z^-~]+)*|"` +
                `([]!#-[^-~ \t]|(\\[\t -~]))+")@[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])` +
                `?(\\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)+`
        )
        //@lint-ignore
        return regex.test(email)
    },
    isValidUrl(url) {
        try {
            new URL(url)
        } catch (e) {
            return false
        }
        return true
    },
    getDaysInMonth(month, year) {
        var date = new Date(year, month, 1)
        var days = []
        while (date.getMonth() === month) {
            days.push(moment(new Date(date)).format('ddd Do'))
            date.setDate(date.getDate() + 1)
        }
        return days
    },
    getDaysWithData(dateGroup, daysArray) {
        const days = [moment(`${dateGroup}-${daysArray[0].day}`).format('ddd Do')];
        const startingIndex = daysArray[0].day === 1 ? 2 : 1

        for(let i = startingIndex; i < daysArray.length; i++){
            days.push(' ');
        }

        days.push(moment(`${dateGroup}-${daysArray[daysArray.length-1].day}`).format('ddd Do'));

        return days
    },
    getDataEntries(dataArray) {
        const data = dataArray.map(dataEntry => {
            return dataEntry.traffic
        })

        if (dataArray[0].day !== 1) {
            return [0, ...data]
        }

        return data
    },
    objAreEqual(obj1, obj2) {
        let isEqual = true
        const keys = Object.keys(obj1)

        keys.forEach(key => {
            if (obj1[key] === undefined || !obj2[key] === undefined || obj1[key] !== obj2[key]) {
                isEqual = false
            }
            console.log('obj1: ' + obj1[key] + ' obj2: ' + obj2[key])
        })

        return isEqual
    },
    dealsHaveChanged(deals, initialDeals) {
        let hasChanges = false
        console.log(deals.length > 0 && !!initialDeals && initialDeals.length > 0)
        if (deals.length > 0 && !!initialDeals && initialDeals.length > 0) {
            for (let i = 0; i < deals.length; i++) {
                if (!hasChanges) {
                    hasChanges = !this.objAreEqual(deals[i], initialDeals[i])
                }
                console.log(deals[i].name + ' ' + initialDeals[i].name)
                console.log(this.objAreEqual(deals[i], initialDeals[i]))
            }
        } else if (deals.length !== 0 || initialDeals.length !== deals.length) {
            hasChanges = true
        }

        return hasChanges
    },
    omit(keys, obj) {
        return Object.fromEntries(Object.entries(obj).filter(([k]) => !keys.includes(k)))
    },
    combineDateTime(date, timeString){
        console.log(`date: ${date} time: ${timeString}`);
        return new Date(`${date.toString().substr(0,10)}T${timeString}:00.000+00:00`);
    },
    getBase64(file) {
        return new Promise(function(resolve, reject) {
            var reader = new FileReader();
            reader.onload = function() { resolve(reader.result); };
            reader.onerror = reject;
            reader.readAsDataURL(file);
        });
    },
    structuredData(data) {
        return JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Website',
            description: data ? data.description : '',
            name: data ? data.name : '',
            potentialAction: {
                '@type': 'SearchAction',
                'query-input': 'required name=q',
                target: location.href
            },
            url: location.href
        })
    }
}
